<!-- <h2>Privacy & Data</h2>

<div *ngIf="loading">Loading...</div>

<div *ngIf="!loading">
  <h3>Preferences</h3>

  <label>
    <input type="checkbox" [(ngModel)]="prefs.analytics">
    Allow analytics cookies
  </label>
  <br>

  <label>
    <input type="checkbox" [(ngModel)]="prefs.marketing">
    Allow marketing emails
  </label>
  <br>

  <button (click)="save()">Save preferences</button>

  <h3>My Data</h3>

  <div class="dsr-dropdown">
    <button type="button" (click)="toggleDropdown()">
      Make a Request
    </button>
    <ul class="dropdown-menu" *ngIf="dropdownOpen">
      <li><button (click)="submitDSR('export')">Export</button></li>
      <li><button (click)="submitDSR('delete')">Delete</button></li>
      <li><button (click)="submitDSR('restrict')">Restrict</button></li>
      <li><button (click)="submitDSR('update')">Update</button></li>
    </ul>
  </div>

  <p>
    See our <a routerLink="/privacy-policy">Privacy Policy</a>.
  </p>
</div> -->
<h3>Effective Date:July 2025</h3>
<h3>Last Updated: January 2026</h3>

<p>
By continuing to use Connekktxchange.com, our mobile applications, and our services (collectively, the “Services”), you acknowledge and agree to our use of cookies and similar tracking technologies as described in this Policy.

1. Use of Tracking Technologies
We, along with our third-party partners and analytics service providers, use standard tracking technologies—including cookies, web beacons, and tags—to provide a high-quality user experience. We use these tools to:

Recognize & Remember: Identify your device and remember your preferences, such as login status, language settings, and display options.

Analyze Performance: Understand how visitors navigate Connekktxchange.com, which helps us improve our website structure and content.

Personalization: Tailor our Services to your specific interests and behavior to greet you by name or show relevant content.

Security & Authentication: Prevent fraudulent activity, authenticate users during login, and ensure secure access to restricted areas of the platform.

2. Types of Cookies We Use
Strictly Necessary Cookies: Essential for the operation of the website. These include cookies that enable you to log into secure areas or fill out forms.

Analytical/Performance Cookies: These allow us to recognize and count the number of visitors and see how they move around the site. We use this to improve site functionality (e.g., ensuring users find what they are looking for easily).

Functionality Cookies: Used to recognize you when you return to our website. This enables us to personalize our content for you and remember your preferences (like your choice of language or region).

Targeting/Advertising Cookies: These record your visit to our website, the pages you have visited, and the links you have followed. We use this information to make our website and the advertising displayed on it more relevant to your interests.

3. Third-Party Cookies
We may use third-party services such as Google Analytics to report usage statistics and deliver relevant advertisements. These third parties (including ad networks and providers of external services like web traffic analysis) may also use cookies over which we have no direct control.

4. Your Choices & Controls
You have the right to manage how cookies are used on your device:

Browser Settings: You can block cookies by activating the setting on your browser that allows you to refuse all or some cookies.

Mobile Settings: Adjust advertising preferences or reset advertising IDs in your device’s privacy settings (iOS or Android).

Consequences of Opting Out: If you use your browser settings to block all cookies (including essential cookies), you may not be able to access all or parts of Connekktxchange.com.

5. "Do Not Track" Signals
At this time, our Services do not respond to "Do Not Track" (DNT) browser signals, as a uniform industry standard for recognizing these signals has not yet been established.

6. Updates to This Policy
We may update this Cookie Policy periodically to reflect changes in technology or legal requirements. We encourage you to review this page regularly for the latest information on our privacy practices.

7. Contact Us
If you have any questions regarding our use of cookies, please contact our Data Protection team at:

Email: support@connekktxchange.com

Website: Connekktxchange.com
</p>